import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { useAtom } from 'jotai'

import { useSubmitRenewPasswordMutation } from '@twisto/api-graphql'
import { TextButton } from '@twisto/components/atoms/button'
import { Container } from '@twisto/components/atoms/container'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { Modal, ModalCloser } from '@twisto/components/atoms/modal'
import { useSubmittingWrapper } from '@twisto/flow-views/components'
import { BigEmailWarningIcon } from '@twisto/icons'
import { styleUtils } from '@twisto/styles'

import {
  submittingFlowFormAtom,
  useGoBack,
  useSubmitLogIn,
} from '../../components'
import { useFlow } from '../../flow/flow.context'

import * as styles from './account-exists-modal.styles'

export const AccountExistsModal = () => {
  const { flow, sessionId } = useFlow<'AccountExistsStep'>()
  const [submitting] = useAtom(submittingFlowFormAtom)
  const goBackInFlow = useGoBack(sessionId)
  const logIn = useSubmitLogIn()
  const [renewPwd] = useSubmitRenewPasswordMutation({
    variables: {
      auth: {
        sessionId,
      },
    },
  })
  const submittingWrapper = useSubmittingWrapper()

  const { email } = flow.currentStep

  const handleRenewPwd = () => submittingWrapper(renewPwd())

  return (
    <Modal
      autoWidth
      noPadding
      aria-label={/*i18n*/ i18n._('flow.accountExistStep.modal.title')}
      data-testid="accountExistStepModal"
      modalBoxStyles={styles.root}
      opened={true}
      onClickOutside={goBackInFlow}
    >
      <ModalCloser onClick={goBackInFlow} />
      <Container noPadding size="tiny">
        <Headline css={styleUtils.margin.bottom.xl}>
          <HeadlineIcon>
            <BigEmailWarningIcon color="warning" height="100%" width="100%" />
          </HeadlineIcon>
          <HeadlineTitle>
            <Trans id="flow.accountExistStep.modal.title" />
          </HeadlineTitle>
          <HeadlineSubtitle>
            <Trans
              id="flow.accountExistStep.modal.subtitle"
              values={{ email: email.value ?? '' }}
            />
          </HeadlineSubtitle>
        </Headline>

        <TextButton
          fullWidth
          css={styleUtils.margin.bottom.xl}
          disabled={submitting}
          onClick={logIn}
        >
          <Trans id="flow.accountExistStep.modal.submit" />
        </TextButton>
        <TextButton
          fullWidth
          color="ghost"
          disabled={submitting}
          onClick={handleRenewPwd}
        >
          <Trans id="flow.accountExistStep.modal.renewPassword" />
        </TextButton>
      </Container>
    </Modal>
  )
}
